import Navigation from "./modules/Navigation";

import Quantity from "./modules/Quantity";
import {Carousels} from "./modules/Carousels";
import {SidebarCart} from "./modules/SidebarCart";
import GoldChart from "./modules/GoldChart";

new Navigation();


Quantity();
SidebarCart();
GoldChart();

Carousels('.featured-section__products', {
    perPage: 1,
    arrows: false,
    mediaQuery: 'min',
    rewind: false,
    rewindByDrag: true,
    pagination: true,
    type: 'loop',
    destroy: true,
    breakpoints: {
        1024: {
            destroy: false,
            arrows: true,
        },
    }
})





document.addEventListener("DOMContentLoaded", function() {
    const lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

    if ("IntersectionObserver" in window) {
        const lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    for (const source in video.target.children) {
                        const videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }

                    video.target.load();
                    video.target.classList.remove("lazy");
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});